import { useState, useEffect } from "react";

// Like useState, but persisted to localStorage under `key`. Used to remember
// table sort preferences across tab switches and page reloads.
export const usePersistentState = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            /* storage unavailable — ignore */
        }
    }, [key, value]);

    return [value, setValue];
};
